import { useBiller } from "hooks";
import _ from "lodash";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import routing from "routing";
import { Spinner } from "kubra-ux-forge";
import { useDispatch, useSelector } from "react-redux";
import { getDeviceFingerprint } from "selectors/appState";
import { setSelectedPayableTypeDefinition } from "actions/selectPayableTypeActions";

export const PayableTypeCsrDirectLanding = () => {
  const dispatch = useDispatch();
  
  const { getBiller } = useBiller();
  const biller = getBiller();

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const payableTypeKrn = params.get('payableTypeKrn');
  const channel = { name: "callcenter" };

  useEffect(() => {
    const selectedDefinition = biller.payableTypeDefinitions.find(
      (payableType) => payableType.typeKrn === payableTypeKrn
    );

    if (!selectedDefinition) return;

    const category = (selectedDefinition.category ?? '').toLowerCase();
    const categoryToRoute: Record<string, string> = {
      freeform: routing.payableAmount.index(),
      order: routing.payableCreateOrder.index(),
    };

    const destination = categoryToRoute[category];
    if (destination) {
      dispatch(setSelectedPayableTypeDefinition(selectedDefinition));
      navigate(destination, { state: channel });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [biller]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            margin: "0 auto",
            height: "50vh",
            backgroundColor: "white",
            width: "75vw",
            justifyContent: "center",
            borderRadius: "24px",
            verticalAlign: "middle",
          }}
        >
          <Spinner size="large" variant="primary" />
        </div>
      </div>
    </>
  );
};

export default PayableTypeCsrDirectLanding;
